/* app/js/src/components/common/circleIndicator/circleIndicator.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  width: 20px;
  height: 20px;
}
div svg {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
div svg path {
  stroke: #141b22;
  stroke-width: 2px;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  fill: none;
}
div svg path.second-layer {
  stroke: #879baf;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 1.8s;
  -webkit-animation-name: rotateShrink;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-delay: 0;
  -moz-animation-duration: 1.8s;
  -moz-animation-name: rotateShrink;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: infinite;
  -o-animation-delay: 0;
  -o-animation-duration: 1.8s;
  -o-animation-name: rotateShrink;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: infinite;
  animation-delay: 0;
  animation-duration: 1.8s;
  animation-name: rotateShrink;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
}
div svg polyline {
  fill: none;
  stroke-width: 3;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  stroke: #879baf;
  transform-origin: center center;
  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
}
div svg polyline.success {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
}
div svg polyline.right {
  opacity: 0;
}
div svg polyline.left {
  opacity: 0;
}
div.loadingDone svg {
  -webkit-animation-delay: 1s;
  -webkit-animation-duration: 0.8s;
  -webkit-animation-name: fadeOut;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 1s;
  -moz-animation-duration: 0.8s;
  -moz-animation-name: fadeOut;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 1s;
  -o-animation-duration: 0.8s;
  -o-animation-name: fadeOut;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 1s;
  animation-duration: 0.8s;
  animation-name: fadeOut;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div.loadingDone svg polyline.success {
  -webkit-animation-delay: 0.2s;
  -webkit-animation-duration: 3s;
  -webkit-animation-name: tickEnter;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0.2s;
  -moz-animation-duration: 3s;
  -moz-animation-name: tickEnter;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0.2s;
  -o-animation-duration: 3s;
  -o-animation-name: tickEnter;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0.2s;
  animation-duration: 3s;
  animation-name: tickEnter;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div.loadingDone svg polyline.failed {
  display: none;
}
div.loadingDone svg path.second-layer {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 2.8s;
  -webkit-animation-name: loadingEnd;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 2.8s;
  -moz-animation-name: loadingEnd;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0s;
  -o-animation-duration: 2.8s;
  -o-animation-name: loadingEnd;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0s;
  animation-duration: 2.8s;
  animation-name: loadingEnd;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div.loadingFailed svg polyline.success {
  display: none;
}
div.loadingFailed svg polyline.right {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: failedRightEnter;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: failedRightEnter;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: failedRightEnter;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: failedRightEnter;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div.loadingFailed svg polyline.left {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: failedLeftEnter;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: failedLeftEnter;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: failedLeftEnter;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: failedLeftEnter;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div.loadingFailed svg path.second-layer {
  -webkit-animation-delay: 0s;
  -webkit-animation-duration: 2.8s;
  -webkit-animation-name: loadingEnd;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0s;
  -moz-animation-duration: 2.8s;
  -moz-animation-name: loadingEnd;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0s;
  -o-animation-duration: 2.8s;
  -o-animation-name: loadingEnd;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0s;
  animation-duration: 2.8s;
  animation-name: loadingEnd;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
@keyframes failedLeftEnter {
  from {
    opacity: 0;
    -ms-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  to {
    opacity: 1;
    -ms-transform: rotate(0);
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
@keyframes failedRightEnter {
  from {
    opacity: 0;
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  to {
    opacity: 1;
    -ms-transform: rotate(0);
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
@-webkit-keyframes failedRightEnter {
  from {
    opacity: 0;
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  to {
    opacity: 1;
    -ms-transform: rotate(0);
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
}
@keyframes loadingEnd {
  to {
    stroke-dasharray: 1000;
  }
}
@-webkit-keyframes loadingEnd {
  to {
    stroke-dasharray: 1000;
  }
}
@keyframes rotateShrink {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rotateShrink {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes tickEnter {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes tickEnter {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}
/*# sourceMappingURL=circleIndicator.component.css.map */
